import React from 'react'
import s from './Tray.scss'
import TraySelected from '../TraySelected'
import TrayMenu from '../TrayMenu'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'

export default ({
  model,
  selected,
  saveFlow,
  saveNode,
  deleteFlow,
  flow,
  publishFlow,
  savePending,
  publishPending,
}) => (
  <div className={cn(s.tray, sLay['layout-column'])}>
    <TraySelected model={model} selected={selected} saveNode={saveNode} flow={flow} />
    {!selected && (
      <TrayMenu
        form={`flow-${flow.id}`}
        flow={flow}
        saveFlow={saveFlow}
        publishFlow={publishFlow}
        deleteFlow={deleteFlow}
        initialValues={flow}
        savePending={savePending}
        publishPending={publishPending}
      />
    )}
  </div>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Tray/Tray.jsx